<template>
  <MountingPortal mountTo="#masonry-modal-portal-target" name="source">
    <div
      v-if="image != null"
      class="image-modal--wrapper"
      @click="$emit('close')"
      role="dialog"
    >
      <div class="image-modal--image">
        <div class="image-modal--image-switcher" v-if="!isLoadingImage">
          <a v-if="prevImage == null" href="#" role="button" class="disabled" disabled @click.stop.prevent :title="langCode == 'se' ? 'Ingen föregående bild' : 'No previous image'"  >
            <span class="fa fa-long-arrow-left"></span>
          </a>
          <a v-else href="#" role="button" :title="langCode == 'se' ? 'Föregående bild' : 'Previous image'" @click.stop.prevent="isLoadingNextImage = true; $emit('prev')">
            <span class="fa fa-long-arrow-left"></span>
          </a>
          <a v-if="nextImage == null" href="#" role="button" class="disabled" @click.stop.prevent disabled :title="langCode == 'se' ? 'Det finns inga fler bilder' : 'No more images'"  >
            <span class="fa fa-long-arrow-right"></span>
          </a>
          <a v-else href="#" role="button" :title="langCode == 'se' ? 'Nästa bild' : 'Next image'" @click.stop.prevent="isLoadingNextImage = true; $emit('next')">
            <span class="fa fa-long-arrow-right"></span>
          </a>
        </div>

        <img
          @click.stop
          v-if="image != null"
          ref="image"
          :style="`opacity:${(isLoadingNextImage ? '0' : '1')}`"
          :class="image.AspectRatio < 1 ? 'image-width' : 'image-height'"
          :alt="image.ImageAltText"
          :src="`/$1/Article/${image.ArticleId}/1/1000x-1/${image.Filename}`"
          @load="isLoadingNextImage=false"
        />

        <div class="image-modal--link-container" v-if="!isLoadingNextImage">
          <span
            class="image-modal--link-item"
            v-for="(link,index) in image.Links"
            :key="index"
          >
            <a :href="link.Url" target="_blank">
              {{link.Text}}
              <span class="fa fa-long-arrow-right"></span>
            </a>
          </span>
        </div>
      </div>
    </div>
  </MountingPortal>
</template>
<script>
export default {
    props: ["image", "nextImage", "prevImage", "langCode"],
    data() {
        return {
            isLoadingNextImage: false,
            isLoadingImage: false
        }
    },
    watch: {
        prevImage(next) {
            if(next) {
                const prevImage = new Image();
                prevImage.src = `/$1/Article/${next.ArticleId}/1/1000x-1/${next.Filename}`;
            }
        },
        nextImage(next) {
            if(next) {
                const prevImage = new Image();
                prevImage.src = `/$1/Article/${next.ArticleId}/1/1000x-1/${next.Filename}`;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.image-modal--wrapper {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  cursor: pointer;
  visibility: visible;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 99999;
  overflow: hidden;

  .image-modal--image {
    opacity: 1;
    cursor: initial;
    position: absolute;
    top: 3rem;
    left: 50%;
    transform: translate(-50%, 0);

    img {
      display: block;
      margin: 0 auto;
      box-shadow: 0 0px 10px 0 hsla(0, 0%, 30%, 1);
        transition: width 1s;
      &.image-width {
        // max-width: 100%;
        width: 50vw;
        max-width: unset;

        @media screen and (max-width: 768px) {
          width: 80vw;
        }
      }
      &.image-height {
        // max-height: 100%;
        max-height: 65vh;
      }
    }

    .image-modal--link-container {
      margin: 0 auto;
      padding: 0.5rem 0;
      list-style: none;
      text-align: left;

      .image-modal--link-item {
        color: #fff;
        font-weight: bold;
        margin: 0;
        white-space: normal;
        width: 100%;
        display: block;
        a {
          color: #fff;
          font-size: 1.2rem;
          // white-space: nowrap;

          &:hover {
            color: #d0d0d0;
          }
        }
      }
    }
  }
}

.image-modal--image-switcher {
  font-size: 2.5rem;
  text-align: center;

  a {
    color: #fff;
    font-weight: bold;
    margin-left: 0.5rem;
    padding: 1rem;

    &.disabled {
      color: #ccc!important;
      cursor:not-allowed;
    }

    &:hover {
      color: #d0d0d0;
    }
  }
}
</style>